module.exports = __webpack_public_path__ + "0c4157ad603336299c75eb152abf55f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_arrow_grey_2x.png
// module id = 133
// module chunks = 0 1 2 3 4